import React, { useEffect } from "react";
import { ExerciseList } from "@/components/exercises/ExerciseList";
import { ExerciseDialog } from "@/components/exercises/ExerciseDialog";
import { Exercise as UIExercise } from "@/components/exercises/exercise.interfaces";
import { useAppToast } from "@/hooks/useAppToast";
import { useExerciseContext } from "./exercises/context";

export const ModuleExercises: React.FC = () => {
  const toast = useAppToast();
  
  const {
    state: { exercises, isRefreshing, error },
    refreshExercises,
    deleteExercise,
    updateExercise,
    addExercise,
    openDialog
  } = useExerciseContext();

  // Load exercises on component mount
  useEffect(() => {
    refreshExercises();
  }, []);

  // Exibir erro se houver
  useEffect(() => {
    if (error) {
      toast.error(`Error: ${error}`);
    }
  }, [error, toast]);

  // Manipular exclusão de exercícios
  const handleDelete = async (exerciseId: string | number) => {
    await deleteExercise(String(exerciseId));
  };

  // Manipular gravação/atualização de exercícios
  const handleSave = async (exercise: UIExercise) => {
    const existingIndex = exercises.findIndex((ex) => ex.id === exercise.id);

    if (existingIndex !== -1) {
      // Preserve existing order when updating
      const existingExercise = exercises[existingIndex];
      // We need to preserve the order property which might be lost in the dialog
      // because the UIExercise interface doesn't explicitly include it in some versions
      const exerciseToUpdate = {
        ...exercise,
        order: (existingExercise as any).order
      };
      
      await updateExercise(exerciseToUpdate);
    } else {
      await addExercise(exercise);
    }
  };

  // Manipular clique no card de exercício (abre o diálogo de edição)
  const handleActiveChange = async (exerciseId: string | number, isActive: boolean) => {
    const exercise = exercises.find((ex) => ex.id === exerciseId);
    if (!exercise) return;
    await updateExercise({ ...exercise, isActive });
  };

  const handleExerciseClick = (exerciseId: string | number) => {
    const exercise = exercises.find(ex => ex.id === exerciseId);
    if (exercise) {
      openDialog(exercise as unknown as UIExercise);
    }
  };

  return (
    <div className="space-y-4">
      {isRefreshing && (
        <div className="text-sm text-blue-500">Updating exercises...</div>
      )}

      <ExerciseList
        exercises={exercises as any[]}
        onDelete={handleDelete}
        onEdit={handleExerciseClick}
        onExerciseClick={handleExerciseClick}
        onExerciseActiveChange={handleActiveChange}
        context="module"
      />

      <ExerciseDialog onSave={handleSave} />
    </div>
  );
};
